import afmRiskImg1 from './AFM_rond_risicoscore1.jpg';
import afmRiskImg2 from './AFM_rond_risicoscore2.jpg';
import afmRiskImg3 from './AFM_rond_risicoscore3.jpg';
import afmRiskImg4 from './AFM_rond_risicoscore4.jpg';
import afmRiskImg5 from './AFM_rond_risicoscore5.jpg';
import afmRiskImg6 from './AFM_rond_risicoscore6.jpg';
import afmRiskImg7 from './AFM_rond_risicoscore7.jpg';

const riskImages : { [key: number]: any }= {
    1 : afmRiskImg1,
    2 : afmRiskImg2,
    3 : afmRiskImg3,
    4 : afmRiskImg4,
    5 : afmRiskImg5,
    6 : afmRiskImg6,
    7 : afmRiskImg7
}

export default riskImages;